<mat-card appearance="outlined">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Partes</h2>
    </div>
  </mat-card-header>
  <mat-card-content *appRoles="['ExpedientesPartes.Crear']">
    <form [formGroup]="expedienteParteForm">
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <app-buscar-persona (eventEntity)="seleccionPersona($event)"></app-buscar-persona>
        </div>
        <div class="col-lg-3 col-sm-12">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTipoParte" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo parte</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="TipoParte">
              <mat-option [value]="tipoParte.id" *ngFor="let tipoParte of tiposParte">
                {{ tipoParte.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-3 col-sm-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col-lg-2 col-sm-12">
          <app-button-add [disabled]="!expedienteParteForm.valid" (click)="onSubmit()"></app-button-add>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-content *appRoles="['ExpedientesPartes.Listar']">
    <ngx-spinner [zIndex]="100" name="spExpedienteParte" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>
    <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data">

  <!-- Tipo Parte -->
  <ng-container matColumnDef="tipoParte">
    <th mat-header-cell *matHeaderCellDef><strong>Tipo Parte</strong></th>
    <td mat-cell *matCellDef="let element">
      {{ element.tipoParte.descripcion }}
    </td>
  </ng-container>

  <ng-container matColumnDef="persona">
  <th mat-header-cell *matHeaderCellDef><strong>Persona</strong></th>
  <td mat-cell *matCellDef="let element">
    <div class="persona-cell">
      <span class="persona-nombre">{{ element.persona.nombreCompleto ?? "" | titlecase }}</span>
      <button mat-icon-button
              class="persona-info-btn"
              (click)="verInfoPersona(element.persona)"
              matTooltip="Info. de la persona">
        <mat-icon>info</mat-icon>
      </button>
    </div>
  </td>
</ng-container>

  <!-- Descripción -->
  <ng-container matColumnDef="descripcion">
    <th mat-header-cell *matHeaderCellDef><strong>Descripción</strong></th>
    <td mat-cell *matCellDef="let element">
      {{ element.descripcion }}
    </td>
  </ng-container>

  <!-- Acción -->
  <ng-container matColumnDef="accion" stickyEnd>
    <th mat-header-cell *matHeaderCellDef><strong>Acción</strong></th>
    <td mat-cell *matCellDef="let element" class="action-cell">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Acciones">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openDialogPersona({  accion: accionesDialog.Ver, idPersona: element.persona.id })" *appRoles="['Personas.Ver']">
          <mat-icon>visibility</mat-icon>
          <span>Ver persona</span>
        </button>
        <button mat-menu-item  (click)="openDialogPersona({ accion: accionesDialog.Modificar, idPersona: element.persona.id })"  *appRoles="['Personas.Modificar']">
          <mat-icon>edit</mat-icon>
          <span>Editar persona</span>
        </button>
        <button mat-menu-item (click)="openDialog('Eliminar', element)">
          <mat-icon>delete</mat-icon>
          <span>Eliminar como parte</span>
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <!-- Filas -->
  <tr mat-header-row *matHeaderRowDef="displayedColumnsExpedienteParte"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumnsExpedienteParte"></tr>

</table>

  </mat-card-content>
</mat-card>
